import { styled } from "styled-components";

import { MediaPreviewContainer } from "app/components/media-preview/MediaPreviewContainer";

import { AD_MODAL_CONTENT_HEIGHT } from "./constants";

export const StyledContainer = styled(MediaPreviewContainer)`
    width: 380px;
    height: ${AD_MODAL_CONTENT_HEIGHT};
    flex-shrink: 0;
`;
